import React from 'react';
import nextStartDate from '../../utils/nextStartDate';

const NextStartDate = () => {
	return (
	  <span>{new nextStartDate().value().format('MMMM Do, YYYY')}</span>
	);
}

export default NextStartDate;
